
















import { iconSiam } from "./iconsiam"





//prevent from removing " " from non "xxx-xxx" pattern.
// prettier-ignore
export const extensionConfigs = {
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  "iconsiam": iconSiam,
  
  
  
  
}
